import React from "react";
import BttfAxios from "@features/utils/axios";
import fileSaver from "file-saver";
import { classNames as cn } from "@features/utils/reactFunctions";

import * as style from "./JSONGeneratorStyle.module.scss";

type Props = {
  label: React.ReactNode;
  baseEndpoint: string;
  fileName?: string;
  buttonClassname?: string;
  customIcon?: React.ReactNode;
};

const JSONGenerator = ({
  label,
  baseEndpoint,
  fileName,
  buttonClassname,
  customIcon,
}: Props) => {
  const [isGenerating, setIsGenerating] = React.useState(false);

  const generateFile = (data: unknown[]) => {
    const blob = new Blob([JSON.stringify(data)], {
      type: "application/json;encoding:utf-8",
    });

    fileSaver.saveAs(blob, `${fileName ?? label}.json`);
  };

  const handleOnClick = () => {
    setIsGenerating(true);
    BttfAxios.get(baseEndpoint, (res) => {
      generateFile(res.data);
      setIsGenerating(false);
    });
  };

  return (
    <button
      onClick={handleOnClick}
      className={
        buttonClassname ?? cn(style.jsonGenerator, isGenerating && style.hide)
      }
    >
      {customIcon ?? <span className="fa fa-download" aria-hidden="true" />}
      {label}
    </button>
  );
};

export default JSONGenerator;
